import { Box, styled } from '@mui/material';

const TopSection = styled(Box)`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export default TopSection;
